// @flow
import * as React from "react"
import styled, { css } from "styled-components"
import media from "@kiwicom/orbit-components/lib/utils/mediaQuery"
import Desktop from "@kiwicom/nitro/lib/components/Desktop"
import { connect } from "react-redux"

import Cookies from "../Cookies/Cookies"
import { isKiwiBrandingSelector } from "common/services/branding/selectors"

const Wrapper = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 600;

  ${media.tablet(css`
    ${({ search }: { search: boolean }) => search && "width: 630px;"};
  `)};

  ${media.desktop(css`
    ${({ search }: { search: boolean }) => search && "width: 750px;"};
  `)};

  @media (min-width: 950px) and (max-width: 999px) {
    ${({ search }: { search: boolean }) => search && "width: 610px;"};
  }

  @media (max-width: 949px) {
    width: 100%;
  }
`
function isSearch(page: string) {
  return ["search", "topRoutes", "flight"].includes(page)
}

type Props = {|
  page: string,
  isSimpleLandingPage: boolean,
|}

const CookiesDesktop = ({ page, isSimpleLandingPage }: Props) => (
  <Desktop>
    <Wrapper search={isSearch(page) && !isSimpleLandingPage} data-test="cookies-desktop">
      <Cookies />
    </Wrapper>
  </Desktop>
)

// $FlowFixMe TODO: plz add type when updating
export default connect(state => ({
  page: state.page.get("name"),
  isSimpleLandingPage: state.options.isRootPage && isKiwiBrandingSelector(state),
}))(CookiesDesktop)
